/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 23/7/2021
 * @Example
 */

import React, { Component } from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Loading } from "../../common/loading/loading";
import GridContainer from "../../common/grid-container/grid-container";
import Config from "../../../config";
import PageContainer from "../../common/page-container/page-container";
import { Row, Col } from 'react-bootstrap';
import { Label } from "reactstrap";
import { browserHistory } from 'react-router';
import PopupScroll from "../../popup/popup-scroll";
import SendMail from "../W17F1002";
import * as userActions from '../../../actions/user-actions';
import * as W17F5565Actions from '../../../actions/w17/W17F5565/w17F5565-actions';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import GridActionBar from '../../common/action-bar/grid-action-bar';
import Modal from '../../common/modal/modal';
import FileViewer from "../../common/fileviewer/fileviewer";
import EventTracking from "../../common/tracking/event";
import ButtonSendMail from '../../common/button/button-sendmail';
import ButtonCustom from '../../common/button/button-custom';

class W17F5565Page extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataSource: [],
            totalItems: 0,
            loading: false,
            showSendMail: false,
            dataMail: null,
            dataSelected: [],
            showFileViewer: false
        }
        this.openedFile = null;
    }

    getInfo = (flag) => {
        const { location } = this.props;
        if (location && location.state) {
            return {
                InventoryID: location.state.InventoryID,
                InventoryName: location.state.InventoryName
            }
        } else {
            if (flag) {
                browserHistory.push(Config.env.url + '/W17F5560');
                return null;
            }
            return false;
        }
    };

    loadPermission = async () => {
        await this.props.userActions.getPermission(Config.profile.UserID, "W17F5560", (iPer) => {
            this.setState({ iPermission: iPer });
        });
    };

    componentDidMount() {
        if (!this.getInfo()) return;
        this.loadPermission();
        let { InventoryID } = this.getInfo();
        if (this.state.iPermission <= 0) return false;
        this.loadform(InventoryID);
    };

    loadform = (InventoryID) => {
        this.setState({ loading: true });
        const params = {
            InventoryID,
            Language: Config.language || 84
        };
        this.props.w17F5565Actions.loadForm(params, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show('INFO', message);
                this.setState({ loading: false });
                return false;
            }
            this.setState({ loading: false, dataSource: data.rows, totalItems: data.total });
        });
    };

    onSendMail = (flag) => {
        const { dataSelected, showSendMail } = this.state;
        flag = typeof flag !== "undefined" ? flag : !showSendMail;
        if (flag) {
            if (dataSelected && dataSelected.length > 0) {
                this.setState({
                    showSendMail: flag,
                    dataMail: {
                        FormID: "W17F5565",
                        KeyID: JSON.stringify(dataSelected.map(d => d.AttachmentID)),
                        DivisionID: ""
                    }
                });
            }
        } else {
            this.setState({ showSendMail: flag });
        }
    };

    onSelectionChanged = (data) => {
        this.setState({ dataSelected: data });
    };

    onDownloadDocument = (row) => {
        fetch(Config.env.cdn + '/' + row.URL).then((response) => {
            return response.blob();
        }).then((myBlob) => {
            var objectURL = URL.createObjectURL(myBlob);
            const link = document.createElement('a');
            link.href = objectURL;
            link.setAttribute('download', row.FileName);
            document.body.appendChild(link);
            link.click();
        });
    };

    renderAction(e) {
        const { iPermission } = this.state;
        return (
            <GridActionBar
                isPer={iPermission}
                tooltipDownload={Config.lang('Tai_U')}
                className={iPermission <= 2 ? 'isDisabled' : ""}
                classNameIs={iPermission}
                onDownloadAction={() => {
                    this.onDownloadDocument(e.row.data)
                }}

            />
        );
    };

    renderViewFile = (e) => {
        if (!e) return null;
        /* eslint-disable */
        return <a onClick={() => this.onViewFiler(e.data)}>{e?.value ?? ''}</a>
    };

    onViewFiler = (file) => {
        this.setState({ showFileViewer: !this.state.showFileViewer });
        const fileName = file && file.FileName ? file.FileName : "";
        const fileType = file && file.fileExt ? file.fileExt : Config.helpers.getExtFile(file ? file.FileName : '');
        const filePath = file && file.URL ? (file.URL.indexOf('http') < 0 ? Config.env.cdn + '/' + file.URL : file.URL) : "";
        this.openedFile = { fileName, fileType, filePath };
    };

    render() {
        if (!this.getInfo(true) && this.state.iPermission <= 0) return null;
        let { InventoryID, InventoryName } = this.getInfo();
        return (
            <PageContainer>
                {Config && Config.profile &&
                    <EventTracking category={"TRACKING_USER"} action={"W17F5565"} label={Config.profile.UserID} />}
                {this.state.showFileViewer &&
                    <Modal open={this.state.showFileViewer} maxWidth={"lg"} fullWidth={true}
                        paperProps={{ style: { height: '100%' } }}
                        title={Config.lang('Xem_tap_tin')}
                        onClose={this.onViewFiler}>
                        <FileViewer
                            fileName={this.openedFile.fileName}
                            filePath={this.openedFile.filePath}
                            fileType={this.openedFile.fileType}
                            height={'100%'} />
                    </Modal>
                }
                {this.state.showSendMail && <PopupScroll
                    title={Config.lang("Gui_mail")}
                    show={true}
                    animation={true}
                    onHide={() => this.onSendMail(false)}>
                    <SendMail companyID={window.location.search.split('CompanyID=')[1]}
                        data={this.state.dataMail}
                        onHide={() => this.onSendMail(false)} />
                </PopupScroll>}
                <div className="grid-title">{Config.lang('Danh_sach_file_dinh_kem')}</div>
                <div style={{ width: 'max-content' }}>
                    <ButtonCustom color={'text-orange'} icon={'fas fa-arrow-alt-left'} isAwesome={true}
                        name={Config.lang("Quay_lai")}
                        onClick={() => browserHistory.goBack()} />
                </div>
                <div>
                    <Row>
                        <Col xs={12} md={4}>
                            <Label>{Config.lang('Ma_hang')}</Label>
                            <span className="pdl10">{InventoryID}</span>
                        </Col>
                        <Col xs={12} md={4}>
                            <Label>{Config.lang('Ten_hang')}</Label>
                            <span className="pdl10">{InventoryName}</span>
                        </Col>
                    </Row>
                    <ButtonSendMail disabled={this.state.dataSelected.length <= 0} onClick={() => this.onSendMail(true)} name={Config.lang("Gui_mail")} />
                </div>
                {this.state.loading && <Loading />}
                {this.state.dataSource && <GridContainer
                    isPer={this.state.iPermission}
                    formID={'W17F5565'}
                    dataSource={this.state.dataSource}
                    totalItems={this.state.totalItems}
                    listPerPage={[15, 20, 30, 50]}
                    selection={{ mode: 'multiple' }}
                    onSelectionChanged={(e, rowData) => this.onSelectionChanged(rowData)}
                >
                    <Column
                        dataField={'FileName'}
                        caption={Config.lang("Ten_file")}
                        minWidth={200}
                        alignment={'left'}
                        cellRender={this.renderViewFile}
                    />
                    <Column
                        cellRender={(data) => this.renderAction(data)}
                        dataField={'bntDownload'}
                        caption={Config.lang("Tai_U")}
                        alignment={'center'}
                        allowSorting={false}
                        showInColumnChooser={false}
                        width={120}
                    />
                    <Column
                        dataField={'FileSize'}
                        caption={Config.lang("Dung_luong")}
                        width={200}
                    />
                </GridContainer>}
            </PageContainer>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        userActions: bindActionCreators(userActions, dispatch),
        w17F5565Actions: bindActionCreators(W17F5565Actions, dispatch)
    }
}

export default connect(null, mapDispatchToProps)(W17F5565Page);
